import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

import { Favorite } from '../interfaces/resources/favorite.interface'
import { Incentive } from '../interfaces/resources/incentive.interface'

@Injectable({
  providedIn: 'root'
})
export class FavoriteService {
  favoriteIncentives = new Subject<Favorite[]>()
  localStorageKey = 'oecdRdTax'

  list(): Favorite[] {
    const appLocalStorage: {
      favoriteIncentives: Favorite[]
    } = JSON.parse(localStorage.getItem(this.localStorageKey) as string)

    return appLocalStorage?.favoriteIncentives || []
  }

  toggle(selectedIncentive: Incentive): boolean {
    const favoriteIncentives: Favorite[] = this.list()

    const isFavorite: boolean = this.isFavorite(selectedIncentive)

    if (isFavorite) {
      favoriteIncentives.splice(
        favoriteIncentives.findIndex(
          (favoriteIncentive) => favoriteIncentive.id === selectedIncentive.id
        ),
        1
      )
    } else {
      favoriteIncentives.push({
        id: selectedIncentive.id,
        label: selectedIncentive.label,
        image: selectedIncentive.country.image
      })
    }

    localStorage.setItem(
      this.localStorageKey,
      JSON.stringify({
        favoriteIncentives
      })
    )

    this.favoriteIncentives.next(favoriteIncentives)
    return !isFavorite
  }

  add(incentives: Incentive | Incentive[]) {
    if (!Array.isArray(incentives)) {
      incentives = [incentives]
    }

    const favoriteIncentives: Favorite[] = this.list()

    incentives.forEach((incentive) => {
      if (!this.isFavorite(incentive)) {
        favoriteIncentives.push({
          id: incentive.id,
          label: incentive.label,
          image: incentive.country.image
        })
      }
    })

    localStorage.setItem(
      this.localStorageKey,
      JSON.stringify({
        favoriteIncentives
      })
    )

    this.favoriteIncentives.next(this.list())
  }

  isFavorite(incentive: Incentive | string): boolean {
    if (typeof incentive === 'string') {
      return !!this.list().find(
        (favoriteIncentive: Favorite) => favoriteIncentive.id === incentive
      )
    }

    return !!this.list().find(
      (favoriteIncentive: Favorite) => favoriteIncentive.id === incentive.id
    )
  }

  removeAllFavorites() {
    localStorage.setItem(
      this.localStorageKey,
      JSON.stringify({
        favoriteIncentives: []
      })
    )
    this.favoriteIncentives.next([])
  }

  remove(ids: string | string[]) {
    if (typeof ids === 'string') {
      ids = [ids]
    }

    localStorage.setItem(
      this.localStorageKey,
      JSON.stringify({
        favoriteIncentives: this.list().filter(
          (favoriteIncentive: { id: string; label: string }) =>
            !ids.includes(favoriteIncentive.id)
        )
      })
    )

    this.favoriteIncentives.next(this.list())
  }

  replaceByNewValues(incentives: Incentive[]) {
    localStorage.setItem(
      this.localStorageKey,
      JSON.stringify({
        favoriteIncentives: incentives.map((incentive) => ({
          id: incentive.id,
          label: incentive.label,
          image: incentive.country.image
        }))
      })
    )
  }
}
